<template>
  <div>
    <!-- Breadcrumb -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-4 ml-3">
        <li class="breadcrumb-item">
          <a href="/" aria-label="Go to home page">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Transport
        </li>
      </ol>
    </nav>

    <div class="card">
      <div class="card-header py-0 px-3">
        <ul class="nav-tabs">
          <li class="nav-link" :class="{ active: activeTab === 'search' }" @click="activeTab = 'search'">
            Timetable
          </li>
          <li
            v-if="showReserve"
            class="nav-link"
            :class="{ active: activeTab === 'reserve' }"
            @click="activeTab = 'reserve'"
          >
            Reserve
          </li>
        </ul>
      </div>
      <div class="card-body">
        <keep-alive include="SearchBus,ReserveBus">
          <SearchBus v-if="activeTab === 'search'" />
          <ReserveBus v-if="showReserve && activeTab === 'reserve'" />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBus from './SearchBus.vue';
import ReserveBus from './ReserveBus.vue';

export default {
  name: 'Transport',
  components: {
    SearchBus,
    ReserveBus,
  },
  data() {
    return {
      activeTab: 'search', // 預設顯示 Timetable tab
      showReserve: true, // 預約功能開關
    };
  },
};
</script>

<style lang="scss" scoped>
.card {
  min-height: calc(100vh - 180px);
}

.nav-tabs {
  height: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  cursor: pointer;
  scrollbar-color: rgba(0, 0, 0, 0.08) transparent;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.nav-tabs::-webkit-scrollbar {
  height: 1px;
}

.nav-tabs::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.08) transparent;
  border-radius: 2px;
}

.nav-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.nav-tabs {
  display: flex;
  align-items: center;
  gap: 24px;

  .nav-link {
    @extend %box-flex-center;
    min-width: 125px;
    margin: 0;
    padding: 20px 0;
    gap: 4px;
    line-height: 100%;
    position: relative;

    &.active {
      border: none;
    }

    &.active::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 4px;
      background-color: #96694c;
    }
  }
}

@media (max-width: 768px) {
  .nav-tabs {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .nav-tabs::-webkit-scrollbar {
    display: none;
  }
}
</style>